import React,{ useEffect, useState } from "react";
import axios from "axios";
// import PropTypes from 'prop-types';  // FOR SAMPLE FORM
import { token, queryParams, domainurl,queryParamsmenu } from './constants/global';

const ExecuteCommand = ({ previousStep,previousValue,triggerNextStep,trigger,step,steps,datas }) => {
    //console.log({datas});
    
    const[msg, setMsg]=useState(datas);
    
    // const[inputtext, setInputtext]=useState();
     
    // const setInputtext = document.getElementByClassName("rsc-input").value = "Johnny Bravo";
    
    useEffect(()=>{
        console.log("execute");
        if(previousStep.message == '')
        {
            var userdata = " "; 
        }
        else
        {
            var userdata = previousStep.message;
        }
        if(queryParamsmenu && step.id=='InitialActivity')
        {
            

        triggerNextStep({ trigger : "homemenu"});

        }
        
    axios.post(domainurl + '/insertchat',{"token":token, "client_id": "919154313830","channel":"web","usermsg": userdata,"botmsg":msg})
   

        
    },[]);
    
    
    return (
        <div>
        {msg}
       
        </div>
    );
};
export default ExecuteCommand;